import { ArrowTooltip } from '@/components/arrow-tooltip.js';
import { cn } from '@/lib/tailwind-utils.js';
import { BookA, Sprout } from 'lucide-react';

export const STUDENT_NEEDS_SPECIAL_COLOR = '#0D9488';
export const STUDENT_NEEDS_SPECIAL_BG_COLOR = 'rgb(204 251 251)';

export const STUDENT_NEEDS_ELL_COLOR = '#FB923C';
export const STUDENT_NEEDS_ELL_BG_COLOR = 'rgb(255 237 213)';

interface StudentNeedsIndicatorsProps {
  specialEd?: boolean | null;
  dyslexic?: boolean | null;
  ell?: boolean | null;
  mode?: 'icons' | 'full-text';
  className?: string;
}

export function StudentNeedsIndicators({
  specialEd,
  dyslexic,
  ell,
  mode = 'icons',
  className,
}: StudentNeedsIndicatorsProps) {
  const hasSpecialNeeds = !!specialEd || !!dyslexic;
  const isMultilingualLearner = !!ell;

  if (!hasSpecialNeeds && !isMultilingualLearner) {
    return null;
  }

  if (mode === 'full-text') {
    return (
      <div className={cn('inline-flex flex-wrap items-center gap-2 normal-case', className)}>
        {hasSpecialNeeds && (
          <span
            className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-sm font-medium"
            style={{
              color: STUDENT_NEEDS_SPECIAL_COLOR,
              backgroundColor: STUDENT_NEEDS_SPECIAL_BG_COLOR,
            }}
          >
            <Sprout className="h-4 w-4 shrink-0" style={{ color: STUDENT_NEEDS_SPECIAL_COLOR }} strokeWidth={2} />
            Special needs
          </span>
        )}
        {isMultilingualLearner && (
          <span
            className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-sm font-medium"
            style={{
              color: STUDENT_NEEDS_ELL_COLOR,
              backgroundColor: STUDENT_NEEDS_ELL_BG_COLOR,
            }}
          >
            <BookA className="h-4 w-4 shrink-0" style={{ color: STUDENT_NEEDS_ELL_COLOR }} strokeWidth={2} />
            Multilingual learner
          </span>
        )}
      </div>
    );
  }

  return (
    <div className={cn('inline-flex items-center gap-1.5 normal-case', className)}>
      {hasSpecialNeeds && (
        <ArrowTooltip
          trigger={
            <span className="inline-flex" aria-label="Special needs">
              <Sprout className="h-4 w-4" style={{ color: STUDENT_NEEDS_SPECIAL_COLOR }} strokeWidth={2} />
            </span>
          }
        >
          Special needs
        </ArrowTooltip>
      )}
      {isMultilingualLearner && (
        <ArrowTooltip
          trigger={
            <span className="inline-flex" aria-label="Multilingual learner">
              <BookA className="h-4 w-4" style={{ color: STUDENT_NEEDS_ELL_COLOR }} strokeWidth={2} />
            </span>
          }
        >
          Multilingual learner
        </ArrowTooltip>
      )}
    </div>
  );
}
